import { modelMedia } from '~/models/content/media.js'

/**
 * Is New if date is within the last 5 days.
 * @returns {boolean}
 */
export const isNew = (date) => {
  if (!date) return false
  const fiveDaysInMilliseconds = 432000000
  const today = new Date().getTime()
  const publishedAtTime = new Date(date).getTime()
  return (today - publishedAtTime) <= fiveDaysInMilliseconds
}

export const modelLightweightArticle = (article) => {
  const date = article.date || article._firstPublishedAt || article.createdAt
  return {
    title: article.title,
    subtitle: article.subtitle,
    slug: article.slug,
    fullSlug: `/explore/${article.category?.slug}/${article.slug}`,
    category: {
      ...article.category,
      fullSlug: `/explore/${article.category?.slug}`
    },
    isNew: isNew(date),
    date,
    media: modelMedia(article.media),
    forceWidth: article.forceWidth,
    forceDoubleWidth: article.forceDoubleWidth,
    contentWordCounter: article.contentWordCounter?.words
  }
}

export const modelArticle = (article) => {
  const date = article.date || article._firstPublishedAt || article.createdAt
  return {
    id: article.id,
    title: article.title,
    slug: article.slug,
    fullSlug: `/explore/${article.category?.slug}/${article.slug}`,
    category: {
      ...article.category,
      fullSlug: `/explore/${article.category?.slug}`
    },
    fullWidthTitle: article.fullWidthTitle,
    isProTeamPage: false,
    isNew: isNew(date),
    date,
    hero: {
      title: article.title,
      date,
      media: {
        image: article.image || {},
        mobileImage: article?.mobileImage || null,
        mobileImageUrl: article.mobileImage?.src || null,
        videoUrl: article.video?.src || null,
        mobileVideoUrl: article.mobileVideo?.src || null
      },
      subtitle: article.subtitle,
      subtitleGradient: article.subtitleGradient.toLowerCase(),
      overlayOpacity: article.overlayOpacity
    },
    content: modelContent(article.content),
    metaGroupTitle: article.metaGroupTitle,
    metaBlock: {
      athleteAvatar: article.athlete?.avatar,
      items: article.metaItems.map(metaItem => ({
        title: metaItem.title,
        person: metaItem.collaborator,
        copy: metaItem.copy
      }))
    },
    meta: article.meta,
    tags: article.tags.map(tag => tag.id)
  }
}

export const modelContent = (content) => {
  return {
    ...content,
    blocks: content.blocks.map((block) => {
      if (block.__typename !== 'ImageRecord' || !block.productCards.length) return block

      return {
        ...block,
        productCards: block.productCards.map((card) => {
          return {
            title: card.title,
            product: {
              ...card.product,
              title: card.product?.title || card.product?.baseProduct?.name,
              sku: card.product?.sku
            }
          }
        })
      }
    })
  }
}

export const modelRelatedArticle = (article) => {
  return {
    id: article.id,
    title: article.title,
    fullSlug: `/explore/${article.category?.slug}/${article.slug}`,
    contentWordCounter: article.contentWordCounter?.words
  }
}
